import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';
import { memo } from 'react';

const SVGComponent = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <Path
      fill={'#000'}
      d="M6 13.5a.53.53 0 0 1-.356-.144.508.508 0 0 1 0-.712L10.294 8l-4.65-4.644a.508.508 0 0 1 .712-.712l5 5a.508.508 0 0 1 0 .712l-5 5A.53.53 0 0 1 6 13.5Z"
      transform="matrix(-1.24938 0 0 1.36724 22.62 1.042)"
    />
  </Svg>
);

const CaretLeft = memo(SVGComponent);
export default CaretLeft;
